import { pages } from '../states/page/actions';
import { copReasonCodes } from '../config';

export const returnBlockedPage = (limit, tryCount) => (tryCount >= limit ? pages.COP.Blocked : null);

export const checkIfMatchFailed = (blockedPage, previousPage, reasonCode) =>
	blockedPage && previousPage !== pages.COP.Blocked && copReasonCodes.countAsRetryAttempt.hasOwnProperty(reasonCode);
